import axios from 'axios';

export const getQuizQuestions = async (contentListingItemId) => {
  const { data } = await axios.get(`/api/content-listings/items/interactive/${contentListingItemId}/questions`);
  return data;
};

export const createQuizQuestion = async (form, contentListingItemId) => {
  const { data } = await axios.post(`/api/content-listings/items/interactive/${contentListingItemId}/questions`, form);
  return data;
};

export const updateQuizQuestion = async (questionId, form) => {
  const { data } = await axios.patch(`/api/content-listings/items/interactive/questions/${questionId}`, form);
  return data;
};

export const deleteQuizQuestion = async (questionId) => {
  const { data } = await axios.delete(`/api/content-listings/items/interactive/questions/${questionId}`);
  return data;
};

export const exportQuizQuestions = async (contentListingItemId) => {
  const response = await axios.get(`/api/content-listings/items/interactive/${contentListingItemId}/questions/export`, {
    responseType: 'blob'
  });
  return response;
};